import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import useMediaQuery from '@mui/material/useMediaQuery';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';

// project imports
import Drawer from './Drawer';
import Header from './Header';
import Footer from './Footer';
import Loader from 'components/Loader';
import Breadcrumbs from 'components/@extended/Breadcrumbs';
import SuperAdminBanner from 'components/SuperAdminBanner';
import WelcomeSetupModal from 'components/WelcomeSetupModal';

import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';

// ==============================|| MAIN LAYOUT ||============================== //

export default function DashboardLayout() {
  const { menuMasterLoading } = useGetMenuMaster();
  const downXL = useMediaQuery((theme) => theme.breakpoints.down('xl'));

  useEffect(() => {
    handlerDrawerOpen(!downXL);
  }, [downXL]);

  const isViewingAsAdmin = localStorage.getItem('viewingAsAdmin') === 'true';

  // Welcome / setup guide — auto-shown once for a company admin who hasn't seen
  // it, and re-openable anytime via the "?" button in the top bar (which fires
  // the 'open-welcome-setup' event). Prefills whatever data already exists.
  const [welcomeOpen, setWelcomeOpen] = useState(false);
  const role = localStorage.getItem('role');
  const tenantId = localStorage.getItem('tenant_id');

  useEffect(() => {
    if (role === 'COMPANY_ADMIN' && tenantId && !localStorage.getItem(`welcome_seen_${tenantId}`)) {
      setWelcomeOpen(true);
    }
    const openHandler = () => setWelcomeOpen(true);
    window.addEventListener('open-welcome-setup', openHandler);
    return () => window.removeEventListener('open-welcome-setup', openHandler);
  }, [role, tenantId]);

  if (menuMasterLoading) return <Loader />;

  return (
    <Box sx={{ display: 'flex', width: '100%', pt: isViewingAsAdmin ? '36px' : 0, minHeight: '100vh', bgcolor: '#F8FAFC' }}>
      <SuperAdminBanner />
      <Header />
      <Drawer />
      <WelcomeSetupModal open={welcomeOpen} onClose={() => setWelcomeOpen(false)} />

      <Box component="main" sx={{ width: 'calc(100% - 260px)', flexGrow: 1, p: { xs: 2, sm: 3 } }}>
        <Toolbar sx={{ mt: 'inherit' }} />
        <Box
          sx={{
            px: { xs: 0, sm: 2 },
            position: 'relative',
            minHeight: 'calc(100vh - 110px)',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Breadcrumbs />
          <Outlet />
          <Footer />
        </Box>
      </Box>
    </Box>
  );
}
